import moment from 'moment';
import { Locale } from 'languages';

export const formatDateByLocale = (date: string, locale: string): string => {
  if (locale === Locale.GERMAN) {
    return moment(date).format('DD.MM.YYYY');
  }
  return date;
};
